var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('form-sejour',{attrs:{"sejourId":_vm.sejourId,"useUser":_vm.useUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }